import React from 'react';
import './styles.css';
import { Route, Switch } from 'react-router-dom';
import Footer from '../../../components/Loja/Footer';
import Header from '../../../components/Loja/Header';
import PremiosLoja from '../../../components/Loja/PremiosLoja';
import Slider from '../../../components/Loja/Slider';
import DetalhePremio from '../../../components/Loja/DetalhePremio';
import Perfil from '../../../components/Loja/Perfil';
import Pontuacoes from '../../../components/Loja/Pontuacoes';
import Resgates from '../../../components/Loja/Resgates';
import ListaPontos from '../../../components/Loja/ListaPontos';
import Contato from '../../../components/Loja/Contato';
import UploadFoto from '../../../components/Loja/UploadFoto';
import Regulamento from '../../../components/Loja/Regulamento';
import ModalRegulamento from '../../../components/Loja/ModalRegulamento';
import Cartao from '../../../components/Loja/Cartao/index';
import Midias from '../../../components/Loja/Midias/index';
import CadastrarVendedor from '../../../components/Loja/CadastrarVendedor/index';
import ModalCep from '../../../components/Loja/Modal/ModalCep';

export default function Home() {
  return (
    <>
      <Header auto />
      <main>
        <Switch>
          <Route
            exact
            path="/loja"
            component={(props) => {
              return (
                <div className="mt-5">
                  <Slider />
                  <PremiosLoja />
                </div>
              );
            }}
          />
          <Route
            exact
            path="/loja/credito"
            component={(props) => <PremiosLoja tipo="credito" />}
          />
          <Route
            exact
            path="/premio/:id"
            component={(props) => <DetalhePremio />}
          />
          <Route exact path="/perfil" component={(props) => <Perfil />} />
          <Route
            exact
            path="/pontuacoes"
            component={(props) => <Pontuacoes />}
          />
          <Route exact path="/resgates" component={(props) => <Resgates />} />
          <Route
            exact
            path="/enviar-pontuacao"
            component={(props) => <UploadFoto />}
          />
          <Route
            exact
            path="/pontos-produtos"
            component={(props) => <ListaPontos />}
          />
          <Route
            exact
            path="/regulamento"
            component={(props) => <Regulamento />}
          />
          <Route
            path="/loja/cadastrar-vendedor/:idRevenda"
            component={(props) => <CadastrarVendedor {...props} />}
          />
          <Route exact path="/cartao" component={(props) => <Cartao />} />
          <Route exact path="/contato" component={(props) => <Contato />} />
          <Route exact path="/fotos-videos" component={(props) => <Midias />} />
        </Switch>
      </main>
      <Footer />
      <ModalRegulamento />
      <ModalCep />
    </>
  );
}
